<div *ngIf="!displayInDialogue">
<a id="marketIndicies" href="javascript:void(0);" class="fw-Icons-marketIndicies"
    attr.aria-label="{{ 'MARKET_SNAPSHOT' | translate}}" tabindex="0" #mattooltipMenuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="tooltipMenu" matTooltip="{{ 'MARKET_SNAPSHOT' | translate}}">
    <svg version="1.1" class="fw-MarketIndicesSvg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 28.9 26.6" style="enable-background:new 0 0 28.9 26.6;" xml:space="preserve">
        <polygon class="fw-MarketIndicesSvg_Icon" points="3.8,26.3 25.1,26.3 25.1,12.8 15,22.8 10.9,18.7 "/>
        <polygon class="fw-MarketIndicesSvg_Icon" points="3.7,21.8 0.5,18.2 11.3,7.8 14.5,11.2 21.5,4.6 18,0.7 28.5,0.5 28.4,11.1 24.6,7 14.5,17.2 11.6,14.2 "/>
    </svg>
</a>
<mat-menu class="tooltip-dialog fw-MarketIndicies_Tooltip" #tooltipMenu="matMenu" [overlapTrigger]="false">
    <div role="menuitem" class="row" *ngFor="let data of dataBlock">
        <h4 class="col-xs-12 fw-MarketIndicies_Title">{{data.Name}}</h4>
        <div class="col-xs-4 positionContainer fw-MarketIndicies_Chart"><img [src]="chartUrl" alt="" class="{{data.Symbol}}" />
        </div>
        <div class="col-xs-4 left-align">
            <span class="fw-MarketIndicies_Header">{{ 'LASTPRICE' | translate}}</span>
            <br />
            <span class="fw-MarketIndicies_Value">{{data.Last | pershingDecimalFormatingPipe: '1.2-2'}}</span>
        </div>
        <div class="col-xs-4 left-align">
            <span class="fw-MarketIndicies_Header">{{ 'TODAYS_CHNAGE' | translate}}</span>
            <br />
            <span class="{{data.ChangeStyle}} fw-MarketIndicies_Value">
                <span class="value">{{data.PriceChange1Day | pershingDecimalFormatingPipe: '1.2-2' }}</span>
                <span class="percent">({{data.PricePctChange1Day | pershingDecimalFormatingPipe: '1.2-2'}}%)</span>
            </span>
        </div>
    </div>
    <div class="row">
        <p role="presentation" class="disclaimer muted col-xs-12">{{ 'AS_OF_TEXT' | translate}} {{timeStamp}}. {{ 'DISCLAIMER' | translate}}
        </p>
    </div>
</mat-menu>
</div>
<div *ngIf="displayInDialogue">
<a id="marketIndicies" (click) = "openMKTDialogue()" class="fw-Icons-marketIndicies"
    attr.aria-label="{{ 'MARKET_SNAPSHOT' | translate}}" tabindex="0">
    <svg version="1.1" class="fw-MarketIndicesSvg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 28.9 26.6" style="enable-background:new 0 0 28.9 26.6;" xml:space="preserve">
        <polygon class="fw-MarketIndicesSvg_Icon" points="3.8,26.3 25.1,26.3 25.1,12.8 15,22.8 10.9,18.7 "/>
        <polygon class="fw-MarketIndicesSvg_Icon" points="3.7,21.8 0.5,18.2 11.3,7.8 14.5,11.2 21.5,4.6 18,0.7 28.5,0.5 28.4,11.1 24.6,7 14.5,17.2 11.6,14.2 "/>
    </svg>
</a>
</div>